import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {
  displayDay,
  displayDuration,
  formatCurrency,
  formatDateTime,
  inventoryAvailable
} from "../../common/Utils";
import MDButton from "../../../components/MDButton";
import {
  addMembershipReservationToCart,
  getInventoryEvent,
  getInventoryMembershipsByEvent
} from "../../common/api/PortalCustomerApi";
import Loading from "../../common/Loading";
import Avatar from "@mui/material/Avatar";
import {Card, CardContent} from "@mui/material";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import MDTypography from "../../../components/MDTypography";
import EventDetail from "../event/EventDetail";
import {UserContext} from "../../../lib/UserProvider";
import {useConfirm} from "../../common/Confirmation";

export default function PreRegisterMemberOnlyEventModal({event, show, refreshCart, handleClose, handleSave}) {
  const [context, setContext] = useContext(AppContext);
  const [userContext, setUserContext] = useContext(UserContext);
  const [fullEvent, setFullEvent] = useState();

  const [modalCounter, setModalCounter] = useState(1);
  const [memberships, setMemberships] = useState();
  const [eventLoading, setEventLoading] = useState(true);

  const [loggedIn, setLoggedIn] = useState(false);
  useEffect(() => {
    setLoggedIn(userContext?.sessionUser?.guid?.length > 0);
  }, [userContext]);

  const getMembershipsByEvent = (guid) => {
    getInventoryMembershipsByEvent(guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setMemberships(result);
      }
    });
  }
  useEffect(() => {
    if (event?.eventType?.memberOnly) {
      getMembershipsByEvent(event.guid);
    }
  }, [event]);

  useEffect(()=>{
    setEventLoading(true);
  },[]);

  useEffect(() => {
    setFullEvent(null);
    setEventLoading(true);
    getInventoryEvent(event.guid).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setFullEvent(result);
        setModalCounter(modalCounter+1);
        setEventLoading(false);
      }
    });

  }, [event]);


  const {confirm, ConfirmationDialog} = useConfirm();
  const [confirmation, setConfirmation] = useState(null);

  const registerEventMembership = async (item) => {

    let _item = {...item};
    item.addingToCart = true;
    _item.quantity = 1;

    let _request = {
      event: event,
      membership: _item
    }

    addMembershipReservationToCart(_request).then((result) => {
      item.addingToCart = false;
      item.addedToCart = true;
      refreshCart();
    });
  };

  const handleCloseFn = () => {
    handleClose();
  };

  return (
    <>
      <Modal onHide={handleCloseFn} size={'lg'} fullscreen={true} dialogClassName={'psb-page-overlay psb-overlay-wide'} show={show}>
        {eventLoading && <Modal.Body>
          <Loading/>
        </Modal.Body>}
        {!eventLoading && fullEvent &&
          <div>
            <Modal.Header closeButton>
              <Modal.Title>{fullEvent.eventType.name} Registration</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Col className={'col col-main'} xs={12}>
                  <Container>
                    <Row>
                      <Row>
                        {modalCounter && fullEvent && <EventDetail
                          event={fullEvent}
                          showDesc={true}
                          embedded={true}
                          full={true}
                          packages={false}
                          callback={()=>{
                            handleClose()
                          }}
                        />}
                      </Row>

                      {(!fullEvent.memberAccountTypes?.length > 0) && memberships && memberships.length > 0 &&
                        <>
                          <Row>
                            <Col className={'col'} sm={12}>
                              <Divider/>
                              {loggedIn && <h5 className={"text-center"}>Available Memberships</h5>}
                              {fullEvent?.eventType?.memberOnly &&

                                <h6 className="text-left">
                                <center>This is a Member Only Event.
                                  Please {!loggedIn ? ' login or create an account.' : 'choose a Membership Option to continue.'}
                                </center>
                                {!loggedIn && <>
                                  <br/>
                                  <br/>
                                  <center>
                                    <MDButton
                                      size={'small'}
                                      color="primary"
                                      onClick={() => {
                                        setUserContext({...userContext, showLogin: true})
                                        handleClose();
                                      }}>Login</MDButton>
                                  </center>
                                </>
                                }
                              </h6>
                              }
                            </Col>
                          </Row>
                          {loggedIn &&

                            <Grid container spacing={2} className="mt-2" alignItems="stretch">
                              {memberships.map((m, index) => {
                                return (
                                  <Grid item xs={12} index={index} key={index}>
                                    <Card p={1} className="modal-card">
                                      <CardContent>
                                        <div className="d-grid-inline">
                                          {m?.imageUrl && <img
                                            className="img-thumbnail pull-left m-2"
                                            alt={fullEvent?.name}
                                            src={m?.imageThumbUrl || m?.imageUrl}
                                          />
                                          }
                                        </div>
                                        <div className="d-grid" style={{
                                          paddingLeft: '15px'
                                        }}>
                                          <MDTypography variant="h6">
                                            <span className={'pull-left'}>{m.name}</span>
                                          </MDTypography>
                                          <p style={{
                                            whiteSpace: 'pre-wrap'
                                          }}>{m.desc}</p>
                                          <p>Price: {formatCurrency(m.price)}</p>

                                          <div className={'text-right'}>
                                            <MDButton variant="gradient"
                                                      color="info"
                                                      size="small"
                                                      onClick={(e) => {
                                                        registerEventMembership(m)
                                                      }}>
                                              Register with {m.name}
                                            </MDButton>
                                          </div>
                                        </div>
                                      </CardContent>
                                    </Card>
                                  </Grid>
                                )
                              })}
                            </Grid>
                          }
                        </>
                      }
                    </Row>
                  </Container>
                </Col>
              </Row>
            </Modal.Body>
          </div>
        }
      </Modal>
    </>
  );
}